import React from "react";
import { Text } from "@/components/atoms/Text/Text";
interface Props {
  errorMessage: string;
  context: string;
  hint?: string;
}
export function ErrorMessage({
  errorMessage,
  context,
  hint
}: Props) {
  return <div className="space-y-2" data-sentry-component="ErrorMessage" data-sentry-source-file="ErrorMessage.tsx">
      <Text variant="body" className="text-zinc-700" data-sentry-element="Text" data-sentry-source-file="ErrorMessage.tsx">
        We had the following error when retrieving {context ?? "your data"}:
      </Text>
      <div className="rounded-lg border border-zinc-100 bg-zinc-50 p-3">
        <Text variant="body" className="!text-red-700" data-sentry-element="Text" data-sentry-source-file="ErrorMessage.tsx">
          {errorMessage}
        </Text>
      </div>
      {hint && <div className="!mt-4">
          <Text variant="body" className="text-zinc-700">
            {hint}
          </Text>
        </div>}
    </div>;
}